import React, {Fragment} from "react";
import ModalConfirm from "../../components/ModalConfirm";
import ModalMsg from "../../components/ModalMsg";
import Translate from "../../components/Translate";
import CommentoController from "./components/CommentoController";

export default function CommentiKpiView({
                                            commenti,
                                            handleDeleteCommento,
                                            loading,
                                            translate,
                                            showConfirm,
                                            setShowConfirm,
                                            eliminaCommento,
                                            show,
                                            setShow,
                                            modalMsg,
                                            parentTab,
                                            parentPaginaTab
                                        }) {

    return (
        <Fragment>
            <ModalConfirm
                show={showConfirm}
                handleClose={() => setShowConfirm(false)}
                handleOk={eliminaCommento}
                testo={translate("Sicuro di voler eliminare il commento?")}/>
            <ModalMsg
                show={show}
                handleClose={() => setShow(false)}
                testo={modalMsg}/>
            {
                !loading && (!commenti || commenti.length === 0) &&
                <span><Translate>Nessun commento presente</Translate></span>
            }
            {
                commenti && commenti.map((commento, index) => (
                    <CommentoController
                        key={index}
                        commento={commento}
                        parentTab={parentTab}
                        parentPaginaTab={parentPaginaTab}
                        addRouteBase={"/add-commento-kpi/" + commento.id_kpi + "/" + commento.id_tipo_imp_dati + "/"} //*Sara*
                        deleteCallback={handleDeleteCommento}
                    />
                    )
                )
            }
        </Fragment>
    );
}
